/* eslint-disable */
import apiClient from './apiClient';

// ==================== Types ====================

export interface ServiceCategory {
    id: number;
    name: string;
    code: string;
    description?: string;
    is_active: boolean;
    created_at?: string;
    updated_at?: string;
}

export interface ServicePrice {
    id: number;
    service_id: number;
    insurance_company_id?: number | null;
    price_type: 'particular' | 'ars' | 'coop' | 'mipyme' | 'other';
    price: number;
    cost_price?: number | null;
    start_date: string;
    end_date?: string | null;
    is_active: boolean;
}

export interface Service {
    id: number;
    name: string;
    code: string;
    category_id: number;
    category?: ServiceCategory;
    description?: string;
    duration_minutes?: number;
    is_active: boolean;
    activePrices?: ServicePrice[];
    created_at?: string;
    updated_at?: string;
}

export interface AdmissionService {
    id: number;
    admission_id: number;
    service_id: number;
    service?: Service;
    ordered_by: number;
    orderedBy?: any;
    performed_by?: number;
    performedBy?: any;
    quantity: number;
    unit_price: number;
    total_price: number;
    notes?: string;
    status: 'pending' | 'performed' | 'cancelled';
    performed_at?: string;
    created_at?: string;
    updated_at?: string;
}

export interface PaginatedResponse<T> {
    data: T[];
    total: number;
    per_page: number;
    current_page: number;
}

export interface ApiResponse<T> {
    success: boolean;
    data: T;
    message?: string;
}

// ==================== Service Category Service ====================

export const serviceCategoryService = {
    async getAll(params: { per_page?: number; search?: string; is_active?: boolean } = {}): Promise<PaginatedResponse<ServiceCategory>> {
        const queryParams = new URLSearchParams();
        if (params.per_page) queryParams.append('per_page', params.per_page.toString());
        if (params.search) queryParams.append('search', params.search);
        if (params.is_active !== undefined) queryParams.append('is_active', params.is_active.toString());

        const response = await apiClient.get<PaginatedResponse<ServiceCategory>>(`/service-categories?${queryParams.toString()}`);
        return response.data;
    },

    async getById(id: number): Promise<ServiceCategory> {
        const response = await apiClient.get<ApiResponse<ServiceCategory>>(`/service-categories/${id}`);
        return response.data.data;
    },

    async create(data: { name: string; code: string; description?: string; is_active?: boolean }): Promise<ServiceCategory> {
        const response = await apiClient.post<ApiResponse<ServiceCategory>>('/service-categories', data);
        return response.data.data;
    },

    async update(id: number, data: Partial<{ name: string; code: string; description: string; is_active: boolean }>): Promise<ServiceCategory> {
        const response = await apiClient.put<ApiResponse<ServiceCategory>>(`/service-categories/${id}`, data);
        return response.data.data;
    },

    async delete(id: number): Promise<void> {
        await apiClient.delete(`/service-categories/${id}`);
    },
};

// ==================== Service Service ====================

export const serviceService = {
    async getAll(params: { page?: number; per_page?: number; search?: string; category_id?: number; is_active?: boolean } = {}): Promise<PaginatedResponse<Service>> {
        const queryParams = new URLSearchParams();
        if (params.page) queryParams.append('page', params.page.toString());
        if (params.per_page) queryParams.append('per_page', params.per_page.toString());
        if (params.search) queryParams.append('search', params.search);
        if (params.category_id) queryParams.append('category_id', params.category_id.toString());
        if (params.is_active !== undefined) queryParams.append('is_active', params.is_active.toString());

        const response = await apiClient.get<PaginatedResponse<Service>>(`/services?${queryParams.toString()}`);
        return response.data;
    },

    async getById(id: number): Promise<Service> {
        const response = await apiClient.get<ApiResponse<Service>>(`/services/${id}`);
        return response.data.data;
    },

    async create(data: { name: string; code: string; category_id: number; description?: string; duration_minutes?: number; is_active?: boolean }): Promise<Service> {
        const response = await apiClient.post<ApiResponse<Service>>('/services', data);
        return response.data.data;
    },

    async update(id: number, data: Partial<{ name: string; code: string; category_id: number; description: string; duration_minutes: number; is_active: boolean }>): Promise<Service> {
        const response = await apiClient.put<ApiResponse<Service>>(`/services/${id}`, data);
        return response.data.data;
    },

    async delete(id: number): Promise<void> {
        await apiClient.delete(`/services/${id}`);
    },

};

// ==================== Admission Service Service ====================

export const admissionServiceService = {
    async getByAdmission(admissionId: number, params: { status?: string } = {}): Promise<AdmissionService[]> {
        const queryParams = new URLSearchParams();
        if (params.status) queryParams.append('status', params.status);

        const response = await apiClient.get<ApiResponse<AdmissionService[]>>(`/admissions/${admissionId}/services?${queryParams.toString()}`);
        return response.data.data;
    },

    async addToAdmission(admissionId: number, data: { service_id: number; quantity?: number; notes?: string }): Promise<AdmissionService> {
        const response = await apiClient.post<ApiResponse<AdmissionService>>(`/admissions/${admissionId}/services`, data);
        return response.data.data;
    },

    async updateService(admissionId: number, serviceId: number, data: Partial<{ quantity: number; notes: string; status: string }>): Promise<AdmissionService> {
        const response = await apiClient.put<ApiResponse<AdmissionService>>(`/admissions/${admissionId}/services/${serviceId}`, data);
        return response.data.data;
    },

    async removeFromAdmission(admissionId: number, serviceId: number): Promise<void> {
        await apiClient.delete(`/admissions/${admissionId}/services/${serviceId}`);
    },
};

export default {
    serviceCategoryService,
    serviceService,
    admissionServiceService,
};
